import { render, staticRenderFns } from "./DistributionErrors.vue?vue&type=template&id=4d1d04d5&"
import script from "./DistributionErrors.vue?vue&type=script&lang=ts&"
export * from "./DistributionErrors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VFlex})
